import styled from 'styled-components'

import { Grid, fromSize } from 'mf-ui-components'

import { spacing } from '../../../../utils/ui/spacing'
import Heading from '../Heading'
import { betweenBreakpoints } from '../../../../utils/style/breakpoint'

export const Container = styled(Grid).attrs({
  as: 'article',
  flow: 'column',
})`
  border: 1px solid ${({ theme }) => theme.tokens.interface.neutral.regular};
  border-radius: 8px;
  overflow: hidden;
  flex-basis: 100%;
`

export const Image = styled.img`
  width: 100%;
  height: 200px;
  object-fit: cover;
`

export const TextContainer = styled.div`
  padding: ${spacing('md')};
  background-color: ${({ theme }) => theme.tokens.space.primary.regular};

  ${fromSize('lg')} {
    padding: ${spacing('lg')};
  }
`

export const TitleContainer = styled(TextContainer)`
  height: 128px;

  ${betweenBreakpoints('lg', 'xl')} {
    > h3 {
      max-width: 100%;
      max-height: 100%;
      overflow: hidden;
      white-space: normal;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
  }
`

export const Title = styled(Heading).attrs({
  level: 3,
  appearAs: 'title5',
  childBlock: true,
})``
